import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";

export default function PrivacyScreen() {
  const navigate = useNavigate();

  const styles = useMemo(() => ({
    page: {
      minHeight: "100vh",
      background: "#ffffff",
      padding: "24px 16px",
      color: "#111",
    },

    container: {
      maxWidth: 900,
      margin: "0 auto",
    },

    title: {
      fontSize: 40,
      fontWeight: 900,
      marginBottom: 8,
    },

    updated: {
      fontSize: 14,
      color: "#666",
      marginBottom: 24,
    },

    p: {
      fontSize: 18,
      lineHeight: 1.9,
      marginBottom: 18,
      color: "#222",
    },

    h: {
      fontSize: 24,
      fontWeight: 800,
      marginTop: 32,
      marginBottom: 12,
      color: "#000",
    },

    ul: {
      paddingLeft: 22,
      marginBottom: 18,
      fontSize: 18,
      lineHeight: 1.9,
      color: "#222",
    },

    back: {
      marginTop: 40,
      padding: "14px 18px",
      fontSize: 16,
      fontWeight: 700,
      borderRadius: 10,
      border: "1px solid #ddd",
      background: "#f5f5f5",
      cursor: "pointer",
    },
  }), []);

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <div style={styles.updated}>Last updated: Jan 28, 2026</div>

        <p style={styles.p}>
          This Privacy Policy explains how <b>Lirivelle</b> collects, uses, stores, and protects your
          information when you use our marketplace platform. Lirivelle allows sellers to create their
          own shops and sell goods or services directly to buyers.
        </p>

        <p style={styles.p}>
          By using Lirivelle, you agree to the collection and use of information in accordance with
          this Privacy Policy.
        </p>

        <div style={styles.h}>1. Information we collect</div>
        <p style={styles.p}>
          We collect information necessary to operate the platform, keep users safe, and allow buyers
          and sellers to interact smoothly.
        </p>

        <ul style={styles.ul}>
          <li><b>Account information:</b> email address, name, profile details.</li>
          <li><b>Seller information:</b> store name, product or service listings, delivery options.</li>
          <li><b>Buyer activity:</b> items viewed, saved items, orders, delivery selections.</li>
          <li><b>Communication data:</b> messages between buyers, sellers, and support.</li>
          <li><b>Technical data:</b> IP address, device type, browser type for security purposes.</li>
        </ul>

        <div style={styles.h}>2. How we use your information</div>
        <p style={styles.p}>
          Your information is used to:
        </p>
        <ul style={styles.ul}>
          <li>Create and manage user and seller accounts.</li>
          <li>Display shops, products, and services.</li>
          <li>Enable communication between buyers and sellers.</li>
          <li>Improve platform performance and user experience.</li>
          <li>Send important system emails such as password resets.</li>
        </ul>

        <div style={styles.h}>3. Payments and financial information</div>
        <p style={styles.p}>
          Lirivelle does <b>not</b> process, hold, or control payments.
        </p>
        <p style={styles.p}>
          All payments are handled directly between buyers and sellers using methods chosen by the
          seller (such as mobile money, bank transfer, cash, or meetup). Lirivelle does not store
          sensitive payment credentials.
        </p>

        <div style={styles.h}>4. Sharing of information</div>
        <p style={styles.p}>
          We do not sell your personal information. Data may be shared only when necessary:
        </p>
        <ul style={styles.ul}>
          <li>Between buyers and sellers to complete transactions.</li>
          <li>With service providers for authentication and hosting.</li>
          <li>If required by law or to prevent fraud or abuse.</li>
        </ul>

        <div style={styles.h}>5. Emails and notifications</div>
        <p style={styles.p}>
          We send emails for account-related actions such as verification and password resets.
          Because Lirivelle is a growing platform, these emails may sometimes appear in spam folders.
        </p>

        <div style={styles.h}>6. Data security</div>
        <p style={styles.p}>
          We take reasonable measures to protect your information. However, no online platform can
          guarantee absolute security. Users are responsible for keeping their login details secure.
        </p>

        <div style={styles.h}>7. Changes to this policy</div>
        <p style={styles.p}>
          We may update this Privacy Policy from time to time. Continued use of the platform means
          you accept the updated policy.
        </p>

        <button style={styles.back} onClick={() => navigate(-1)}>
          ← Back
        </button>
      </div>
    </div>
  );
}
